module.exports = __webpack_public_path__ + "static/3-47c30aa5677bd198d9fa04f9707808e7.jpg";